import { render, staticRenderFns } from "./VacationsApprovedDayLegend.vue?vue&type=template&id=24e422e9&"
import script from "./VacationsApprovedDayLegend.vue?vue&type=script&lang=js&"
export * from "./VacationsApprovedDayLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports